<template>
    <div>
        <div style="display: flex; justify-content: space-between;">
            <DatePicker v-model="range" range lang="vi" format="DD/MM/YYYY" name="time" :shortcuts="shortcuts">
            </DatePicker>
            <div>
                <b-button variant="outline-primary" @click="openEditDataModal" class="mr-2">
                    <i class="fa fa-plus mr-2"></i>
                    <span class="text-uppercase">Tạo dữ liệu</span>
                </b-button>
                <b-button variant="outline-primary" @click="openUploadModal">
                    <i class="fa fa-upload mr-2"></i>
                    <span class="text-uppercase">Tải lên dữ liệu</span>
                </b-button>
                <b-button variant="outline-success" @click="downloadTemplate" class="ml-2">
                    <i class="fa fa-download mr-2"></i>
                    <span class="text-uppercase">Tải dữ liệu mẫu</span>
                </b-button>
            </div>
        </div>
        <b-table class="mt-2" striped hover sticky-header no-border-collapse :items="listData" :fields="fieldsData"
            show-empty :filter-included-fields="['name']" style="max-height: 500px;">
            <template v-slot:cell(index)="data">{{
                (currentPage - 1) * 50 + data.index + 1
            }}</template>
            <template v-slot:cell(time)="data">
                <span>{{ data.value | formatDateTime }}</span>
            </template>
            <template v-slot:cell(actions)="row">
                <b-button variant="primary" class="mr-1 min-width-none" @click="openEditDataModal(row.item)"
                    v-b-tooltip.hover :title="$t('common.edit')">
                    <i class="fa fa-pencil"></i>
                </b-button>
                <b-button variant="danger" @click="confirmDeleteData(row.item)" v-b-tooltip.hover class="min-width-none"
                    :title="$t('common.delete')">
                    <i class="fa fa-trash"></i>
                </b-button>
            </template>
            <template v-slot:empty>
                <div class="text-center">
                    <span>Không có dữ liệu</span>
                </div>
            </template>
        </b-table>
        <div class="mt-3 float-left">{{ formattedCountRow }} kết quả</div>
        <b-pagination v-model="currentPage" :total-rows="countRow" :per-page="50" class="my-0" align="right" />

        <b-modal ref="uploadDataModal" ok-title="Lưu" title="Tải lên dữ liệu" @ok="handleUploadOk"
            :cancel-title="$t('common.cancel')">
            <b-form-group label="File dữ liệu">
                <b-form-file v-model="file" v-validate="'required'" name="file" placeholder="Chọn file dữ liệu"
                    drop-placeholder="Kéo file dữ liệu vào đây" accept=".xlsx, .xls, .csv"
                    data-vv-as="File dữ liệu"></b-form-file>
                <div v-show="errors.has('file')" class="validation-message text-danger">
                    {{ errors.first('file') }}
                </div>
            </b-form-group>
        </b-modal>

        <b-modal ref="updateDataModal" :title="formData.id ? 'Cập nhật' : 'Tạo mới'" ok-title="Lưu"
            @ok="handleUpdateDataOk" :cancel-title="$t('common.cancel')">
            <b-form-group label="Thời gian">
                <DatePicker v-model="formData.time" type="datetime" format="DD/MM/YYYY HH:mm" :show-minute="false"
                    :show-second="false" v-validate="'required'" name="time" data-vv-as="Thời gian"></DatePicker>
                <div v-show="errors.has('time')" class="validation-message text-danger">
                    {{ errors.first('time') }}
                </div>
            </b-form-group>
            <b-form-group label="Loại dữ liệu">
                <b-form-input v-model="formData.type" placeholder="Ví dụ: Mực nước (m)" name="type"></b-form-input>
            </b-form-group>
            <b-form-group label="Giá trị">
                <b-form-input v-model="formData.value" placeholder="Giá trị" name="value"></b-form-input>
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';

export default {
    components: {
        DatePicker
    },
    async mounted() {
        await this.$nextTick();
        this.getData();
    },
    props: {
        pointId: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            fieldsData: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'time',
                    label: 'Thời gian'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'type',
                    label: 'Loại dữ liệu'
                },
                {
                    tdClass: 'align-middle',
                    thClass: 'fixed-actions-col',
                    key: 'value',
                    label: 'Giá trị'
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions'),
                    thStyle: { width: '150px' }
                }
            ],
            formData: {},
            listData: [],
            file: null,
            currentPage: 1,
            countRow: null,
            shortcuts: [
                {
                    text: 'Hôm nay',
                    onClick() {
                        return [new Date(), new Date()];
                    }
                },
                {
                    text: 'Hôm qua',
                    onClick() {
                        const start = new Date();
                        start.setDate(start.getDate() - 1);
                        const end = new Date();
                        end.setDate(end.getDate() - 1);
                        return [start, end];
                    }
                },
                {
                    text: '7 ngày qua',
                    onClick() {
                        const start = new Date();
                        start.setDate(start.getDate() - 7);
                        const end = new Date();
                        return [start, end];
                    }
                },
                {
                    text: '30 ngày qua',
                    onClick() {
                        const start = new Date();
                        start.setDate(start.getDate() - 30);
                        const end = new Date();
                        return [start, end];
                    }
                }
            ],
            range: null
        };
    },
    watch: {
        currentPage(value) {
            this.getData(value);
        },
        range() {
            this.currentPage = 1;
            this.getData();
        }
    },
    computed: {
        formattedCountRow() {
            return Number(this.countRow || 0).toLocaleString('vi-VN');
        }
    },
    methods: {
        ...mapActions({
            getListData: 'data/getList',
            createData: 'data/create',
            uploadData: 'data/upload',
            updateData: 'data/update',
            deleteData: 'data/delete'
        }),
        async openEditDataModal(item) {
            this.formData = { ...item, time: new Date(item.time) };
            this.$refs.updateDataModal.show();
        },
        async openUploadModal() {
            this.file = null;
            this.$refs.uploadDataModal.show();
        },
        downloadTemplate() {
            const templateUrl = `${process.env.BASE_URL}file/mau_du_lieu_upload.xlsx`;
            const link = document.createElement('a');
            link.href = templateUrl;
            link.download = 'mau_du_lieu_upload.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async handleUploadOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(async result => {
                if (!result) return;
                await this.uploadData({
                    formData: {
                        file: this.file,
                        pointId: this.pointId
                    }
                });
                await this.getData();
                this.$toaster.success('Thành công');
                this.$refs.uploadDataModal.hide();
            });
        },
        async confirmDeleteData(item) {
            const result = await this.$bvModal.msgBoxConfirm('Bạn có chắc chắn muốn xoá không?', {
                title: 'Xác nhận',
                okVariant: 'danger',
                okTitle: 'Có',
                cancelTitle: 'Không'
            });
            if (result) {
                await this.deleteData(item);
                await this.getData();
                this.$toaster.success('Xoá thành công');
            }
        },
        async handleUpdateDataOk(modal) {
            modal.preventDefault();
            this.$validator.validateAll().then(async result => {
                if (!result) return;
                if (this.formData.id) {
                    await this.updateData(this.formData);
                } else {
                    await this.createData({ ...this.formData, pointId: this.pointId });
                }
                await this.getData();
                this.$toaster.success('Thành công');
                this.$refs.updateDataModal.hide();
            });
        },
        async getData() {
            const data = await this.getListData({
                pointId: this.pointId,
                page: this.currentPage,
                from: this.range ? this.range[0] : null,
                to: this.range ? this.range[1] : null
            });
            this.listData = data.items;
            this.countRow = data.metadata.total;
        }
    }
};
</script>
<style>
.mx-datepicker-sidebar {
    width: 120px;
}
</style>
